'use strict';

const getFirstPage = (page, pageCount)=>{
    return Math.floor((page - 1) / pageCount) * pageCount + 1;
};
const getLastPage = (firstPage, pageCount, maxPage)=>{
    return Math.min(firstPage + pageCount - 1, maxPage);
};
const getPageButtonCount = (firstPage, lastPage)=>{
    return lastPage - firstPage + 1;
};

exports.getFirstPage = getFirstPage;
exports.getLastPage = getLastPage;
exports.getPageButtonCount = getPageButtonCount;
